import ENUMS from '../constants/card-brand-type-enums';
import { BRAZIL_COUNTRY_CODE } from '../constants/common-enums';

/**
 * get card type displayed on UI based on merchant and card type response
 * 1. If card is not combo card, display whatever backend returns
 * 2. If card is combo card, following case will return 'CREDIT', otherwise return 'ElECTRON'
 *     2.1 backend card type is credit, (only 1 counter case when BR merchant supports electron only)
 *     2.2 merchant country is BR, merchant accepts visa only (support visa && does not support electron)
 * @param {boolean} isComboCard
 * @param {string} type
 * @param {array} merchantSupportedCardBrands
 * @param {string} merchantCountryCode
 * @returns {string} 'CREDIT' / 'DEBIT' / 'ELECTRON'
 */

const getCardType = (isComboCard, type, merchantSupportedCardBrands, merchantCountryCode) => {
  if (
    !Array.isArray(merchantSupportedCardBrands) ||
    typeof type !== 'string' ||
    typeof isComboCard !== 'boolean'
  ) {
    return null;
  } else if (!isComboCard) {
    /* 1 */
    return type;
  } else if (
    /* 2.1 */
    (type === ENUMS.CARD_TYPES.CREDIT) ^
      (type === ENUMS.CARD_TYPES.CREDIT &&
        merchantSupportedCardBrands.includes(ENUMS.CARD_BRANDS.ELECTRON) &&
        !merchantSupportedCardBrands.includes(ENUMS.CARD_BRANDS.VISA) &&
        merchantCountryCode === BRAZIL_COUNTRY_CODE) ||
    /* 2.2 */
    (!merchantSupportedCardBrands.includes(ENUMS.CARD_BRANDS.ELECTRON) &&
      merchantSupportedCardBrands.includes(ENUMS.CARD_BRANDS.VISA) &&
      merchantCountryCode === BRAZIL_COUNTRY_CODE)
  ) {
    return ENUMS.CARD_TYPES.CREDIT;
  }
  return ENUMS.CARD_BRANDS.ELECTRON;
};
export default getCardType;
